// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .collapse-separator {
  display: block;
  position: relative;
  margin: 16px 0 18px 25px;
  border-top: 1px solid #E3E3E3;
  border-bottom: 1px solid #E3E3E3;
  height: 4px;
  cursor: pointer;
  transition: margin 500ms;
  z-index: 1;
}
.presize-root .collapse-separator.expanded {
  margin: 16px 0 18px -4px;
}
.presize-root .collapse-separator .amount {
  display: block;
  border: 1px solid #d0d1d3;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  position: absolute;
  left: 0;
  top: -11px;
  background: #ffffff;
}
.presize-root .collapse-separator .amount .icon {
  font-size: 14px;
  line-height: 24px;
}
.presize-root .collapse-separator .amount .icon-hover {
  display: none;
  font-size: 10px;
}
.presize-root .collapse-separator .amount .icon-hover .icon-up {
  position: relative;
  top: -7px;
  left: 5px;
}
.presize-root .collapse-separator .amount .icon-hover .icon-down {
  position: relative;
  bottom: -1px;
  left: -5px;
}
.presize-root .collapse-separator .amount:hover,
.presize-root .collapse-separator .amount.expanded {
  background-color: #efeff0;
}
.presize-root .collapse-separator .amount:hover .number {
  display: none;
}
.presize-root .collapse-separator .amount:hover .icon-hover {
  display: block;
  padding-top: 2px;
}
.presize-root .collapse-separator .separator-selector {
  margin-left: 27px;
}
/*# sourceMappingURL=CollapseSeparator.css.map */`, "",{"version":3,"sources":["webpack://./CollapseSeparator.less","webpack://./src/components/SizingGroup/ArticleList/CollapseSeparator/CollapseSeparator.less"],"names":[],"mappings":"AAAA;EAEE,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;ACAF;ADCE;EACE,wBAAA;ACCJ;ADbA;EAeI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;ACCJ;AD3BA;EA4BM,eAAA;EACA,iBAAA;ACEN;AD/BA;EAgCM,aAAA;EACA,eAAA;ACEN;ADnCA;EAoCM,kBAAA;EACA,SAAA;EACA,SAAA;ACEN;ADxCA;EAyCM,kBAAA;EACA,YAAA;EACA,UAAA;ACEN;ADAI;;EAEE,yBAAA;ACEN;ADjDA;EAoDM,aAAA;ACAN;ADpDA;EAuDM,cAAA;EACA,gBAAA;ACAN;ADxDA;EA4DI,iBAAA;ACDJ;AACA,gDAAgD","sourcesContent":[".presize-root { \n .collapse-separator {\n  display: block;\n  position: relative;\n  margin: 16px 0 18px 25px; // -8px from margin bottom of previous table\n  border-top: 1px solid #E3E3E3; // neutral-n400\n  border-bottom: 1px solid #E3E3E3; // neutral-n400\n  height: 4px;\n  cursor: pointer;\n  transition: margin 500ms;\n  z-index: 1;\n  &.expanded {\n    margin: 16px 0 18px -4px;\n  }\n  .amount {\n    display: block;\n    border: 1px solid #d0d1d3; // neutral-n400;\n    border-radius: 12px;\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    line-height: 24px;\n    text-align: center;\n    position: absolute;\n    left: 0;\n    top: -11px;\n    background: #ffffff;\n    .icon {\n      font-size: 14px;\n      line-height: 24px;\n    }\n    .icon-hover {\n      display: none;\n      font-size: 10px;\n    }\n    .icon-hover .icon-up {\n      position: relative;\n      top: -7px;\n      left: 5px;\n    }\n    .icon-hover .icon-down {\n      position: relative;\n      bottom: -1px;\n      left: -5px;\n    }\n    &:hover,\n    &.expanded {\n      background-color: #efeff0;\n    }\n  }\n  .amount:hover {\n    .number {\n      display: none;\n    }\n    .icon-hover {\n      display: block;\n      padding-top: 2px;\n    }\n  }\n  .separator-selector {\n    margin-left: 27px;\n  }\n}\n \n}",".presize-root .collapse-separator {\n  display: block;\n  position: relative;\n  margin: 16px 0 18px 25px;\n  border-top: 1px solid #E3E3E3;\n  border-bottom: 1px solid #E3E3E3;\n  height: 4px;\n  cursor: pointer;\n  transition: margin 500ms;\n  z-index: 1;\n}\n.presize-root .collapse-separator.expanded {\n  margin: 16px 0 18px -4px;\n}\n.presize-root .collapse-separator .amount {\n  display: block;\n  border: 1px solid #d0d1d3;\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 24px;\n  text-align: center;\n  position: absolute;\n  left: 0;\n  top: -11px;\n  background: #ffffff;\n}\n.presize-root .collapse-separator .amount .icon {\n  font-size: 14px;\n  line-height: 24px;\n}\n.presize-root .collapse-separator .amount .icon-hover {\n  display: none;\n  font-size: 10px;\n}\n.presize-root .collapse-separator .amount .icon-hover .icon-up {\n  position: relative;\n  top: -7px;\n  left: 5px;\n}\n.presize-root .collapse-separator .amount .icon-hover .icon-down {\n  position: relative;\n  bottom: -1px;\n  left: -5px;\n}\n.presize-root .collapse-separator .amount:hover,\n.presize-root .collapse-separator .amount.expanded {\n  background-color: #efeff0;\n}\n.presize-root .collapse-separator .amount:hover .number {\n  display: none;\n}\n.presize-root .collapse-separator .amount:hover .icon-hover {\n  display: block;\n  padding-top: 2px;\n}\n.presize-root .collapse-separator .separator-selector {\n  margin-left: 27px;\n}\n/*# sourceMappingURL=CollapseSeparator.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
